import { Link } from 'react-router-dom';
import { Card, CardContent, Typography, Grid } from '@mui/material';

const ToolList = ({tools}) => {
    return(
        <Grid container spacing={3}>
        {/* Everytime you use map in react or really anything that is going to dynamically 
        change the length and order of the list, your going to need to add a key prop
        to the outer most element in the list such as this Link, and that it has a unique
        value.
        */}
        {tools.map(tool => (
            <Grid item xs={12} sm={6} md={4} key={tool.name}>
                <Card
                    component={Link}
                    to={`/tools/${tool.name}`}
                    sx={{
                    textDecoration: 'none',
                    color: 'inherit',
                    height: '100%',
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': { transform: 'scale(1.03)' },
                    }}
                >
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {tool.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {tool.content[0].substring(0, 120)}...
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        ))
        }
    </Grid>
    )
}

export default ToolList;